import React from 'react';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { TextField } from '@mui/material';
import { toast } from 'react-toastify';

export const ValidatedMobileDatePicker = (props: any) => {
  const { renderInput, ...restProps } = props;
  const [error, setError] = React.useState<boolean>(false);

  const validateDate = (dateString: any) => {
    setError(false); 
    const dateParts = dateString.split('/');
    const year = parseInt(dateParts[0], 10);
    const month = parseInt(dateParts[1], 10);
    const day = parseInt(dateParts[2], 10);

    if (month < 1 || month > 12) {
      toast.error('Please enter a month between 1 and 12.');
      setError(true);
    }

    const daysInMonth = new Date(year, month, 0).getDate();
    if (day < 1 || day > daysInMonth) {
      toast.error(`Please enter a day between 1 and ${daysInMonth} for the selected month.`);
      setError(true);
    }

    return !error;
  };

  return (
    <MobileDatePicker
      {...restProps}
      renderInput={(params) => {
        const renderedInput = renderInput ? renderInput(params) : <TextField {...params} />;

        return React.cloneElement(renderedInput, {
          onBlur: (e: any) => {
            validateDate(e.target.value);

            if (renderedInput.props.onBlur) {
              renderedInput.props.onBlur(e);
            }
          },
        });
      }}
    />
  );
};